import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import Admin from "./components/Admin";
import ServiceDetail from "./components/ServiceDetail";
import LocationDetail from "./components/LocationDetail";
import AboutPage from "./components/AboutPage";
import ReferenzenPage from "./components/ReferenzenPage";
import FloatingActions from "./components/FloatingActions";
import CookieBanner from "./components/CookieBanner";
import { Toaster } from "./components/ui/toaster";

function MainSite() {
  return (
    <>
      <Header />
      <main>
        <Home />
      </main>
      <FloatingActions />
      <CookieBanner />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <div className="site-reveal">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainSite />} />
            <Route path="/leistungen/:slug" element={<ServiceDetail />} />
            <Route path="/gebaeudereinigung/:slug" element={<LocationDetail />} />
            <Route path="/ueber-uns" element={<AboutPage />} />
            <Route path="/referenzen" element={<ReferenzenPage />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
